export function zd (res) {
  let chart = {
    grid: {
      left: 10,
      right: 20,
      bottom: 10,
      top: 60,
      width: 'auto',
      containLabel: true
    },
    legend: {
      show: true
    },
    boundaryGap: true,
    alignWithLabel: true,
    color: ['#1895FF', '#1EE4DC', '#FFD71A'],
    xData: [],
    series: [],
    yAxis: [
      {
        name: '台',
        type: 'value',
        min: 0
      },
      {
        name: '元',
        type: 'value',
        min: 0,
        splitNumber: 2,
        axisLabel: {
          textStyle: {
            color: 'rgba(255,255,255,.6)'
          }
        },
        nameTextStyle: {
          color: '#999'
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255,255,255,0.1)'
          }
        }
      }
    ]
  }

  return {
    chart,
    listsLabel: handlerZDlist(res)
  }
}
function handlerZDlist (res) {
  let list = [
    {
      label: '主页活跃用户',
      key: 'mouthUserNum',
      value: 0,
      dw: '万'
    },
    {
      label: '主页付费用户',
      key: 'payUserNum',
      value: 0,
      dw: '万'
    },
    {
      label: '主页付费ARPU值',
      key: 'arpu',
      value: 0,
      dw: '元'
    }
  ]
  list.forEach(item => {
    if (item.dw === '万') {
      item.value = (res[item.key] / 10000).toFixed(2) + item.dw
      return
    }
    item.value = (res[item.key] || 0.00).toFixed(2) + item.dw
  })
  return list
}

export function yuyinyewu () {
  let depRevenueTrend = {
    grid: {
      left: 10,
      right: 20,
      bottom: 10,
      containLabel: true
    },
    legend: {
      show: false
    },
    boundaryGap: true,
    alignWithLabel: true,
    color: ['#1895FF', '#1EE4DC', '#FFD71A'],
    xData: [],
    series: []
  }
  return depRevenueTrend
}

export function zhongduanfenbuChartOptions (refsThis) {
  if (refsThis.$refs['echartChina']) {
    refsThis.$refs['echartChina'].options.visualMap.show = false
    refsThis.$refs['echartChina'].options.geo.label.normal.fontSize = '10'
    refsThis.$refs['echartChina'].options.geo.label.normal.formatter = (e) => {
      let item = refsThis.$refs['echartChina'].options.series[0].data.find(item => item.name === e.name)
      if (item) {
        return `${item.name}\n${parseInt((item.value / 10000))}`
      }
      return e.name
    }
    refsThis.$refs['echartChina'].options.geo.label.normal.color = '#fff'
    refsThis.$refs['echartChina'].setChartInit()
  }
}
/// 地图label
export function setChinaLabel ({ res, vue }) {
  let list = [
    {
      label: '拓展终端数(万)',
      value: 0,
      dw: ''
    },
    {
      label: '广告终端数(万)',
      value: 0,
      dw: ''
    },
    {
      label: '直播终端(万)',
      value: 0,
      dw: ''
    }
    // {
    //   label: '直播覆盖省',
    //   value: 12,
    //   dw: ''
    // }
    // {
    //   label: 'ARPU值(元)',
    //   value: 0,
    //   dw: ''
    // }
    // {
    //   label: '直播终端ARPU值(元)',
    //   value: 0,
    //   dw: ''
    // },
    // {
    //   label: '广告终端ARPU值(元)',
    //   value: 0,
    //   dw: ''
    // }
  ]
  let zdtotal = res.media
  list[0].value = (zdtotal.other / 10000).toFixed(2) + list[0].dw
  list[1].value = (zdtotal.adTermCnt / 10000).toFixed(2) + list[1].dw
  list[2].value = (zdtotal.liveUserNum / 10000).toFixed(0) + list[2].dw
  return list
}

/// 语音业务
export function voice ({ res, vue }) {
  let chart = setVoiceCharts({ res, vue })
  return {
    chart,
    listsLabel: handlerVoicelist(res)
  }
}

function handlerVoicelist (res) {
  let list = [
    {
      label: '日新增转化率',
      key: 'dayActiveCountRatio',
      value: 0,
      dw: '%'
    },
    {
      label: '7日新增转化率',
      key: 'activeCountRatio',
      value: 0,
      dw: '%'
    },
    {
      label: '7日留存率',
      key: 'retentionRate',
      value: 0,
      dw: '%'
    }
  ]
  list.forEach(item => {
    if (item.dw === '%') {
      item.value = (res[item.key] * 100).toFixed(2) + item.dw
      return
    }
    item.value = res[item.key] + item.dw
  })
  return list
}

function setVoiceCharts ({ res, vue }) {
  let options = {
    grid: {
      left: 10,
      right: 20,
      bottom: 10,
      containLabel: true
    },
    legend: {
      show: true
    },
    boundaryGap: true,
    alignWithLabel: true,
    xData: [],
    yAxis: {
      type: 'value',
      splitNumber: 5,
      label: {
        show: true
      }
    },
    series: []
  }

  let monthDetailArr = Object.entries(res.monthDetail)
  monthDetailArr.forEach(item => {
    options.series.push(
      {
        data: item[1].data,
        type: 'line',
        smooth: true,
        name: item[0]
      }
    )
    options.xData = item[1].date.map(date => {
      return vue.$cUtils.format.formatDate(date, 'MM-dd')
    })
  })

  return options
}

/// 融媒体
export function rongmeiti ({ res, vue }) {
  let chart = setRongCharts({ res, vue })
  return {
    chart,
    listsLabel: handlerRongMeilist(res.indicators)
  }
}

function handlerRongMeilist (res) {
  let list = [
    {
      label: '县级融媒体数量',
      key: 'indicatorValueA',
      value: 0,
      dw: ''
    },
    {
      label: '年累计签约金额',
      key: 'indicatorValueA',
      value: 0,
      dw: '万'
    },
    {
      label: '县级签约产出',
      key: 'indicatorValueA',
      value: 0,
      dw: '万'
    }
  ]
  list.forEach((item, index) => {
    if (item.dw === '万') {
      item.value = (res[index] ? res[index][item.key] : 0 / 10000).toFixed(2) + item.dw
      return
    }
    item.value = res[index] ? res[index][item.key] : 0 + item.dw
  })
  return list
}
function setRongCharts ({ res, vue }) {
  let options = {
    grid: {
      left: 10,
      right: 20,
      bottom: 10,
      top: '25%',
      containLabel: true
    },
    legend: {
      show: true
    },
    boundaryGap: true,
    alignWithLabel: true,
    xData: [],
    yAxis: [
      {
        name: '营收',
        nameTextStyle: {
          color: '#fff'
        },
        type: 'value',
        label: {
          show: true
        },
        axisLabel: {
          color: 'rgba(255,255,255,1)'
        },
        splitNumber: 4
      },
      {
        name: '数量',
        nameTextStyle: {
          color: '#fff'
        },
        type: 'value',
        label: {
          show: true
        },
        axisLabel: {
          color: 'rgba(255,255,255,1)'
        },
        splitNumber: 4
      }
    ],
    xAxis: {
      name: '月',
      nameTextStyle: {
        padding: [0, 0, 0, 10],
        color: '#fff'
      }
    },
    series: []
  }
  let monthDetailEnteris = Object.entries(res.monthDetail)
  monthDetailEnteris.forEach((item, index) => {
    options.xData = item[1].date.map(date => {
      return vue.$cUtils.format.formatDate(date, 'MM')
    })
    options.series.push(
      {
        data: item[1].data,
        type: index < 1 ? 'line' : 'bar',
        yAxisIndex: index < 1 ? 1 : 0,
        smooth: true,
        name: item[0]
      }
    )
  })
  return options
}

/// 投影仪
export function touyingyi ({ res, vue }) {
  let chart = setTouyingyiCharts({ res, vue })
  return {
    chart,
    listsLabel: handlerTouyingyilist(res)
  }
}

function handlerTouyingyilist (res) {
  let list = [
    {
      label: '目标值/完成率',
      key: 'completion',
      value: 0,
      dw: ''
    },
    {
      label: '月度累计出库',
      key: 'outboundCumulative',
      value: 0,
      dw: '万元'
    },
    {
      label: '月度累计销售',
      key: 'cumulative',
      value: 0,
      dw: '万元'
    },
    {
      label: '实时存货余额',
      key: 'stockMonthlyTotal',
      value: 0,
      dw: '万元'
    }
  ]
  list.forEach((item, index) => {
    if (item.dw === '万元') {
      item.value = res[item.key + 'Num'] + '台/' + res[item.key + 'Amount'] + item.dw
      return
    }
    if (item.key === 'completion') {
      item.value = res[item.key + 'Target'] + '台/' + (res[item.key + 'Rate'] * 100).toFixed(2) + '%'
      return
    }
    item.value = res[item.key + 'Num'] + '/' + res[item.key + 'Amount']
  })
  return list
}
function setTouyingyiCharts ({ res, vue }) {
  let options = {
    // color: ['#2888df', '#61a5e6', '#edbd7e', '#32d8da', '#01ffff'],
    grid: {
      left: '10%',
      right: '20%',
      bottom: '10%',
      top: '25%',
      containLabel: false
    },
    legend: {
      show: true,
      data: [
        { name: '实时出库金额', icon: 'rect' },
        { name: '实时销售金额', icon: 'rect' },
        { name: '实时出库数量', icon: 'path://M0 0h300v100h-300z' },
        { name: '实时销售数量', icon: 'path://M0 0h300v100h-300z' }
      ]
    },
    boundaryGap: true,
    alignWithLabel: false,
    xData: [],
    yAxis: [
      {
        // name: '',
        nameTextStyle: {
          color: '#fff'
        },
        type: 'value',
        label: {
          show: false
        },
        axisLabel: {
          color: 'rgba(255,255,255,1)'
        },
        splitNumber: 4
      },
      {
        // name: '',
        nameTextStyle: {
          color: '#fff'
        },
        type: 'value',
        label: {
          show: true
        },
        axisLabel: {
          color: 'rgba(255,255,255,1)'
        },
        splitNumber: 4
      }
    ],
    xAxis: {
      // name: '',
      nameTextStyle: {
        padding: [0, 0, 0, 10],
        color: '#fff'
      }
    },
    series: []
  }
  let saleMoneyList = []
  let saleNumberList = []
  let saleoutMoneyList = []
  let saleoutNumberList = []
  if (!res.procectorItemList) {
    return
  }
  res.procectorItemList.forEach((item, index) => {
    options.xData.push(item.billdate.slice(-4))
    saleMoneyList.push(item.saleMoney)
    saleNumberList.push(item.saleNumber)
    saleoutMoneyList.push(item.saleoutMoney)
    saleoutNumberList.push(item.saleoutNumber)
  })
  options.series.push(
    {
      data: saleoutMoneyList,
      type: 'bar',
      stack: 'money',
      yAxisIndex: 0,
      name: '实时出库金额'
    }, {
      data: saleMoneyList,
      stack: 'money',
      type: 'bar',
      yAxisIndex: 0,
      name: '实时销售金额'
    }, {
      data: saleoutNumberList,
      type: 'line',
      yAxisIndex: 1,
      smooth: true,
      symbol: 'none',
      name: '实时出库数量'
    },
    {
      data: saleNumberList,
      type: 'line',
      yAxisIndex: 1,
      symbol: 'none',
      smooth: true,
      name: '实时销售数量'
    }
  )
  return options
}
